<template>
  <v-tabs class="sub-menu" slider-color="primary" height="64" style="margin-bottom: 15px;" background-color="transparent">
    <!--    <v-tab class="sub-menu-item" to="/delegation-info/trip-policy">-->
    <!--      <v-icon class="sub-menu-item-icon">info</v-icon>-->
    <!--      {{ $t("delegationInfoMenu.tripPolicy") }}-->
    <!--    </v-tab>-->
    <template v-if="isLoaded">
      <v-tab
        v-if="hasPermissionForDelegationTask && $store.getters['userProperties'].system_settings.is_delegation_task_enabled === 2"
        class="sub-menu-item"
        to="/delegation-info/delegation-task"
      >
        <v-icon class="sub-menu-item-icon">assignment</v-icon>
        {{ $t("delegationInfoMenu.delegationTask") }}
      </v-tab>
      <v-tab v-if="hasPermissionForVehicles" to="/delegation-info/vehicle" class="sub-menu-item">
        <v-icon class="sub-menu-item-icon">directions_car</v-icon>
        {{ $t("delegationInfoMenu.vehicle") }}
      </v-tab>
      <v-tab to="/delegation-info/exchange-rate" class="sub-menu-item">
        <v-icon class="sub-menu-item-icon">attach_money</v-icon>
        {{ $t("delegationInfoMenu.exchangeRate") }}
      </v-tab>
      <v-tab v-if="hasPermissionForDelegationRate" to="/delegation-info/delegation-rate" class="sub-menu-item">
        <v-icon class="sub-menu-item-icon">account_balance</v-icon>
        {{ $t("delegationInfoMenu.delegationRates") }}
      </v-tab>
      <v-tab :to="'/delegation-info/' + customWebpage.alias" class="sub-menu-item" :key="customWebpage.id" v-for="customWebpage of customWebpages">
        <v-icon class="sub-menu-item-icon">{{ customWebpage.icon }}</v-icon>
        {{ customWebpage.title }}
      </v-tab>
    </template>
  </v-tabs>
</template>

<script>
export default {
  name: "DelegationInfoMenu",
  data: () => ({
    customWebpages: [],
    isLoaded: false
  }),
  mounted() {
    this.$store.dispatch("Visual/setMenuBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  },
  computed: {
    hasPermissionForDelegationTask() {
      //return (this.$store.getters.hasPermission('manageDelegationTask') || (this.$store.getters.hasPermission('viewDelegationTask')));
      return true;
    },
    hasPermissionForDelegationRate() {
      //return (this.$store.getters.hasPermission('viewDelegationRate') || (this.$store.getters.hasPermission('manageDelegationRate')));
      return true;
    },
    hasPermissionForVehicles() {
      //return (this.$store.getters.hasPermission('manageVehicles') || (this.$store.getters.hasPermission('viewVehicles')));
      return true;
    }
  },
  created() {
    this.axios.get("custom-webpage/get-list").then(resp => {
      this.customWebpages = resp.data;
      this.isLoaded = true;
    });
  }
};
</script>

<style scoped>
.sub-menu-item {
  font: bold 16px Merriweather, serif;
  text-transform: none;
}

.sub-menu-item-icon {
  margin-right: 15px;
}
</style>

<style>
.sub-menu .v-tabs__bar {
  background-color: inherit;
}
</style>
